import { render, staticRenderFns } from "./FormulaLibraryDetail.vue?vue&type=template&id=a96142ac&scoped=true"
import script from "./FormulaLibraryDetail.vue?vue&type=script&lang=js"
export * from "./FormulaLibraryDetail.vue?vue&type=script&lang=js"
import style0 from "./FormulaLibraryDetail.vue?vue&type=style&index=0&id=a96142ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96142ac",
  null
  
)

export default component.exports